(function () {
  var BREAKPOINT = 990; // doit correspondre au media query CSS
  var YOUTUBE_EMBED_BASE = 'https://www.youtube-nocookie.com/embed/';

  function getSources(section) {
    var sectionId = section.getAttribute('data-section-id');
    var script = document.querySelector(
      '[data-hero-video-sources="' + sectionId + '"]'
    );
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* --------------------------------------------------------------------
     Source "upload" (vidéo hébergée par Shopify) : autoplay classique,
     aucun enjeu cookies/consentement (premier parti).
     -------------------------------------------------------------------- */
  function loadUploadedVideo(section, slot, sources) {
    var isDesktop = window.innerWidth >= BREAKPOINT;
    var src = isDesktop ? sources.desktop : sources.mobile;
    if (!src) src = isDesktop ? sources.mobile : sources.desktop;
    if (!src) return;

    if (prefersReducedMotion()) return;

    var video = document.createElement('video');
    video.setAttribute('src', src);
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
    video.preload = 'auto';

    video.addEventListener('loadeddata', function () {
      section.classList.add('is-video-ready');
    });

    video.play().catch(function () {
      /* poster reste visible, pas d'erreur bloquante */
    });

    slot.appendChild(video);
  }

  /* --------------------------------------------------------------------
     Vérifie le consentement "marketing" via l'API officielle Shopify
     Customer Privacy. Consentmo (comme la plupart des CMP Shopify) y est
     directement intégré, donc ce check reste valable même si l'outil de
     consentement change un jour.
     -------------------------------------------------------------------- */
  function checkMarketingConsent(callback) {
    var callbackCalled = false;
    function safeCallback(value) {
      if (callbackCalled) return;
      callbackCalled = true;
      callback(value);
    }

    // Filet de sécurité : si l'API de consentement ne répond pas dans les
    // 2 secondes (bug, contexte d'aperçu de l'éditeur, etc.), on affiche
    // quand même le bouton de lecture plutôt que de rester bloqué.
    var timeoutId = setTimeout(function () {
      safeCallback(false);
    }, 2000);

    try {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        clearTimeout(timeoutId);
        safeCallback(false);
        return;
      }
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          clearTimeout(timeoutId);
          if (error) {
            safeCallback(false);
            return;
          }
          try {
            var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
            safeCallback(consent && consent.marketing === 'yes');
          } catch (e) {
            safeCallback(false);
          }
        }
      );
    } catch (e) {
      clearTimeout(timeoutId);
      safeCallback(false);
    }
  }

  function buildYoutubeIframe(videoId, section, muted) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute(
      'src',
      YOUTUBE_EMBED_BASE +
        videoId +
        '?autoplay=1&mute=' +
        (muted ? '1' : '0') +
        '&loop=1&playlist=' +
        videoId +
        '&controls=0&modestbranding=1&playsinline=1&rel=0'
    );
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('title', 'Démonstration du protocole SculptLift');
    iframe.setAttribute('frameborder', '0');
    iframe.className = 'hero-sculptlift__youtube-iframe';
    iframe.addEventListener('load', function () {
      section.classList.add('is-video-ready');
    });
    return iframe;
  }

  /* --------------------------------------------------------------------
     Source "youtube" : autoplay MUET si le consentement marketing est déjà
     donné (visiteur récurrent) — muet requis par les navigateurs pour
     l'autoplay automatique. Sinon, pattern "click-to-load" avec SON activé,
     puisque le clic est un geste explicite de l'utilisateur qui n'a pas
     cette contrainte technique.
     -------------------------------------------------------------------- */
  function loadYoutubeVideo(section, slot, sources) {
    var isDesktop = window.innerWidth >= BREAKPOINT;
    var videoId = isDesktop ? sources.youtubeDesktop : sources.youtubeMobile;
    if (!videoId) videoId = isDesktop ? sources.youtubeMobile : sources.youtubeDesktop;
    if (!videoId) return;

    checkMarketingConsent(function (hasConsent) {
      if (hasConsent) {
        slot.appendChild(buildYoutubeIframe(videoId, section, true));
        return;
      }

      var playButton = document.createElement('button');
      playButton.type = 'button';
      playButton.className = 'hero-sculptlift__play-button';
      playButton.setAttribute('aria-label', 'Lancer la vidéo');
      playButton.innerHTML =
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M7 4L20 12L7 20V4Z" fill="currentColor"/></svg>';

      playButton.addEventListener('click', function () {
        playButton.remove();
        slot.appendChild(buildYoutubeIframe(videoId, section, false));
      });

      slot.appendChild(playButton);
    });
  }

  function initHeroVideo(section) {
    var slot = section.querySelector('[data-video-slot]');
    if (!slot) return;

    var sources = getSources(section);
    if (!sources) return;

    if (sources.source === 'youtube') {
      loadYoutubeVideo(section, slot, sources);
    } else {
      loadUploadedVideo(section, slot, sources);
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('.hero-sculptlift');
    sections.forEach(function (section) {
      // Ne prépare la vidéo/le bouton que quand la section entre dans le viewport
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                initHeroVideo(section);
                observer.disconnect();
              }
            });
          },
          { rootMargin: '200px' }
        );
        observer.observe(section);
      } else {
        initHeroVideo(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();